import React from 'react';

export function ProcessingModal({ show }) {
    if (!show) {
        return null;
    }

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-zinc-100/35 px-4 backdrop-blur-sm">
            <section
                role="dialog"
                aria-modal="true"
                aria-label="処理中"
                aria-busy="true"
                className="flex items-center gap-3 rounded-xl border border-red-500/40 bg-zinc-900 px-5 py-4 shadow-2xl shadow-zinc-400/30"
            >
                <span className="h-5 w-5 animate-spin rounded-full border-2 border-red-300 border-t-transparent" aria-hidden="true"></span>
                <p className="text-sm font-semibold text-zinc-100">処理中</p>
            </section>
        </div>
    );
}
